if (!customElements.get('product-partner-upsell')) {
  customElements.define('product-partner-upsell', class ProductPartnerUpsell extends HTMLElement {
    constructor () {
      super()

      this.elements = {
        addTrigger: this.querySelector('[data-partner-upsell-el="addTrigger"]'),
        variantSelectors: this.querySelectorAll('[data-partner-upsell-el="variantSelector"]'),
        parentAddToCartForm: null,
        parentSubmitButton: null,
        pushCart: document.querySelector('cart-notification') || document.querySelector('cart-drawer'),
      }

      this.state = {
        parentId: this.dataset.partnerUpsellParentId,
        enablePartnerSubmit: false,
        selectedVariant: this.dataset.partnerUpsellSelectedVar,
      }
    }

    connectedCallback () {
      this.elements.parentAddToCartForm = this.parentElement.parentElement.querySelector(`product-form[data-product-id="${this.state.parentId}"] form`)
      this.elements.parentSubmitButton = this.elements.parentAddToCartForm.querySelector('[data-add-to-cart]')

      this.elements.addTrigger.addEventListener('change', () => {
        if (this.elements.addTrigger.checked) {
          this.state.enablePartnerSubmit = true
          this.elements.parentAddToCartForm.dataset.includePartnerProduct = true
          this.trackTrigger()
        } else {
          this.state.enablePartnerSubmit = false
          this.elements.parentAddToCartForm.dataset.includePartnerProduct = false
        }
      })

      this.elements.variantSelectors.forEach((selector) => {
        selector.addEventListener('change', () => {
          if (selector.checked) {
            this.dataset.partnerUpsellSelectedVar = selector.value
            this.state.selectedVariant = selector.value
          }
        })
      })

      this.elements.parentAddToCartForm.addEventListener('submit', () => {
        if (this.elements.parentSubmitButton.dataset.notifyMe === 'false' && this.state.enablePartnerSubmit) {
          document.addEventListener('product-added-to-cart', () => {
            this.addPartnerToCart()
          }, { once: true })
        }
      })
    }

    addPartnerToCart () {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: this.state.selectedVariant,
          quantity: 1,
        }),
      })
        .then(res => res.json())
        .then(res => {
          this.elements.pushCart.renderContents(res)
          this.trackAddToCart()
        })
        .catch(err => console.error(err))
    }

    trackAddToCart () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'bundle_upsell_add_to_cart',
      })
    }

    trackTrigger () {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'bundle_upsell_trigger',
      })
    }
  })
}
